{
  "about": {
    "paragraph": "AGEC yasasının getirdiği zorluklarla başa çıkmaya ve müşterilerimizi ürünlerimizin kökeni ve çevresel nitelikleri hakkında bilgilendirmeye kararlıyız.",
    "title": "Hakkında"
  },
  "lastUpdate": "Son Güncelleme Tarihi : ",
  "loading": {
    "dataPending": "şu anda bu bilgileri topluyor",
    "pendingLocation": "Bekleyen konum"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Giyim Üretimi",
    "FOOTWEAR_FINISHING": "Ayakkabı Bitirme",
    "FOOTWEAR_STITCHING": "Ayakkabı Dikimi",
    "FOOTWEAR_ASSEMBLING": "Ayakkabı Montajı",
    "FABRIC_WEAVING_OR_KNITTING": "Kumaş Dokuma veya Örme",
    "FABRIC_DYEING_PRINTING": "Kumaş Boyama veya Baskı",
    "YARN_PROVIDER": "İplik Tedarikçisi",
    "YARN_DYEING_PRINTING": "İplik Boyama veya Baskı",
    "LEATHER_TANNING": "Deri Tabaklama",
    "LEATHER_DYEING_PRINTING": "Deri Boyama veya Baskı",
    "ACCESSORY_PROVIDER": "Aksesuar Tedarikçisi",
    "YARN_MATERIAL_PRODUCTION": "İplik Malzeme Üretimi",
    "FABRIC_SPINNING": "Kumaş Eğirme",
    "FABRIC_MATERIAL_PRODUCTION": "Kumaş Malzeme Üretimi",
    "LEATHER_MATERIAL_PRODUCTION": "Deri Malzeme Üretimi",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Aksesuar Hammadde Tedarikçisi",
    "COATING": "Kaplama"
  },
  "other": {
    "microplastics_bold": "mikroplastik salar ",
    "paragraph1": "Bu ürün şunları içerir ",
    "paragraph1_100": "Bu ürün %100 geri dönüştürülmüş malzemeler içerir.",
    "paragraph2_1": "Bu ürün ",
    "paragraph2_2": "  yıkama sırasında çevreye: ",
    "paragraph2_3": "ürünün kütlesine göre sentetik liflerden oluşur.",
    "paragraph3": "Uygulamada tehlikeli maddelerin potansiyel varlığı hakkında bilgi: ",
    "recycled_matertials_bold": "en az {{percent}}% geri dönüştürülmüş malzeme.",
    "recycled_matertials_bold_50": "%50'den fazla ",
    "title": "Diğer çevresel nitelikler ve özellikler"
  },
  "packaging": {
    "recyclable": "Geri dönüştürülebilir: Ambalaj geri dönüştürülebilirdir.",
    "recycled": "Geri dönüştürülmüş malzemeler: Ambalaj en az {{percent}}% geri dönüştürülmüş malzeme içerir.",
    "recycled_100": "Geri dönüştürülmüş malzemeler: Ambalaj %100 geri dönüştürülmüş malzeme içerir.",
    "title": "Ambalajın çevresel nitelikleri ve özellikleri"
  },
  "title": "Çevresel Nitelikler veya Özellikler Üzerine Ürün Bilgi Sayfası",
  "traceability": {
    "paragraph": "Bu, ürününüzün ilk üç üretim aşamasındaki kökenine, yaratımından ana malzemesinin dokunmasına ve boyanmasına kadar atıfta bulunur.",
    "title": "Ürün İzlenebilirliği"
  },
  "ecoScore": {
    "title": "EcoScore"
  }
}
